import Axios from 'axios' 
import {
  USERINFO_UNSET_ALL_STATE,
  USERINFO_SET_MSG,
  USERINFO_UNSET_MSG,
  USERINFO_SET_SCHEMA,
  USERINFO_UNSET_SCHEMA,
  USERINFO_SET_ACTION_PROCESS,
  USERINFO_UNSET_ACTION_PROCESS,
  USERINFO_SET_LIST_DATA, 
  USERINFO_UNSET_LIST_DATA,
  USERINFO_SET_ACTION_STATUS,
  USERINFO_UNSET_ACTION_STATUS

} from '../mutation-types'

const state = {     
  dataList: [],   
  message: '',
  actionStatus:false, 
  actionProcess:false, 
  Schema:{ 
    name:'',
    active: 1,
    user_id: 0,
    user_name: '',
    password: '',
    email: '',
    institute_id: '',
    create_date: '',
    created_user_id: '',
    activation_key: '',
    id:0,
    role_id:0,
  }
}

const getters = {
  get_USERINFO_DataList (state) {
    return state.dataList ;
  }, 
  get_USERINFO_ActionMessage(state){
    return state.message ;
  },
  get_USERINFO_Schema(state){
    return state.Schema
  },
  get_USERINFO_ActionProcess(state){
    return state.actionProcess ;
  },
  get_USERINFO_ActionStatus(state){
    return state.actionStatus ;
  },

}

// mutations

const	mutations = {	
  [USERINFO_UNSET_ALL_STATE] (state){
    state.actionProcess = false,
    state.dataList = [],      
    state.Schema = {
      name:'',
      active: 1,
      user_name: '',
      password: '',
      email: '',
      institute_id: '',
      create_date: '',
      created_user_id: '',
      activation_key: '',
      id:0,
      role_id:0,
    }  
  },
  [USERINFO_SET_ACTION_STATUS](state){
    state.actionStatus = true
  },
  [USERINFO_UNSET_ACTION_STATUS](state){
    state.actionStatus = false
  },
  [USERINFO_SET_MSG](state,msg){
    state.message = msg
  },
  [USERINFO_UNSET_MSG](state){
    state.message = ""
  },
  [USERINFO_UNSET_ACTION_PROCESS]( state ){ 
    state.actionProcess = false
  },
  [USERINFO_SET_ACTION_PROCESS]( state ){
    state.actionProcess = true 
  },
  [USERINFO_SET_LIST_DATA](state,itemList){
    state.dataList = itemList 
  },
  [USERINFO_UNSET_LIST_DATA](state){
    state.dataList = [] 
  },
  [USERINFO_SET_SCHEMA](state,schemaData){
    state.Schema = schemaData 
  },
  [USERINFO_UNSET_SCHEMA](state){
    state.Schema = [] 
    state.Schema.active =1
  },
}

// Actions

const actions = {
}

export default {
 state,
 getters,
 actions,
 mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/dia_userinfo_module.js